export default function Footer() {
  const footerLinks = [
    { href: '#hero', label: '首页' },
    { href: '#carousel', label: '焦点专题' },
    { href: '#cards', label: '分类导航' },
    { href: '#index', label: '主题索引' },
    { href: '#updates', label: '最新动态' },
    { href: '#faq', label: '常见问题' },
    { href: '#contact', label: '联系我们' },
    { href: '#about', label: '关于我们' },
  ];

  const domainVariants = [
    '7777影院', '777777影院', '77777影院', '7777777影院',
  ];

  return (
    <footer id="footer" className="bg-background-950 text-background-300">
      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="inline-flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50"></i>
              </div>
              <span className="text-lg font-semibold font-heading text-background-50 whitespace-nowrap">
                777影院
              </span>
            </a>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              777影院是集合了7777影院、777777影院、77777影院等数字变体的官方影视导航平台，为全国影迷提供安全、稳定、免费的高清电影电视剧在线观看入口。
            </p>
            <div className="flex flex-wrap gap-1.5">
              {domainVariants.map((v) => (
                <span
                  key={v}
                  className="px-2.5 py-1 text-xs bg-background-800/50 text-background-400 rounded-md whitespace-nowrap"
                >
                  {v}
                </span>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">快速导航</h4>
            <nav className="flex flex-col gap-2">
              {footerLinks.slice(0, 4).map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* More Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">更多链接</h4>
            <nav className="flex flex-col gap-2">
              {footerLinks.slice(4).map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Partners */}
          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              感谢所有合作伙伴对777影院的支持与信任。我们欢迎更多优质平台与我们携手合作，共同为影迷提供更好的服务体验。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a
                href="#contact"
                className="inline-flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap"
              >
                <i className="ri-service-line"></i>
                商务合作
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-800/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2020 - 2026 777影院官方网站. 保留所有权利.
          </p>
          <p className="text-xs text-background-500">
            本站为影视导航平台，所有内容均来自互联网公开资源
          </p>
        </div>
      </div>
    </footer>
  );
}